import { createIcon } from './createIcon'

export const DownloadIcon = createIcon({
  displayName: 'DownloadIcon',
  viewBox: '0 0 14 20',
  path: [
    <path
      d="M14 20H0V18H14V20ZM7 16L1 10L2.41 8.59L6 12.17V0H8V12.17L11.59 8.59L13 10L7 16Z"
      fill="currentColor"
    />,
  ],
})
